import { useCallback } from 'react';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';
import { Task } from 'shared/types/task';

import { useUpdateLifeArea } from './use-update-life-area';

export const useDeleteLifeAreaSection = () => {
  const { submit: updateLifeArea } = useUpdateLifeArea();

  return useCallback(
    (lifeArea: LifeArea, sectionId: ID, _tasks?: Task[]) => {
      updateLifeArea({
        id: lifeArea.id,
        sections: lifeArea.sections?.filter(({ id }) => id !== sectionId),
      });
    },
    [updateLifeArea],
  );
};
